module.exports = __webpack_public_path__ + "static/media/kitapaktivasyonu_ADIM4.8d606a60.jpg";